// extracted by mini-css-extract-plugin
export default {"Badge":"styles_Badge__xFNoH","active":"styles_active__F+wuz"};